import script from "./Horizontal.vue?vue&type=script&lang=ts&setup=true"
export * from "./Horizontal.vue?vue&type=script&lang=ts&setup=true"

import "./Horizontal.vue?vue&type=style&index=0&id=42c98aaa&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c98aaa"]])

export default __exports__